const MOBILE_MAX = 767
const TABLET_MIN = 768
const TABLET_MAX = 1024
const DESKTOP_MIN = 1025

export const isMobile = () => window.innerWidth <= MOBILE_MAX
export const isTablet = () =>
	window.innerWidth >= TABLET_MIN && window.innerWidth <= TABLET_MAX
export const isDesktop = () => window.innerWidth >= DESKTOP_MIN
